import { render, staticRenderFns } from "./proposal-valid-until.vue?vue&type=template&id=25eefe1f"
import script from "./proposal-valid-until.vue?vue&type=script&lang=js"
export * from "./proposal-valid-until.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports